import log from 'loglevel';
import i18n from 'i18next';
import config from 'i18n-config';
import Cookies from 'universal-cookie';
import { Lang, getLang } from 'utils/get-lang';
import { initReactI18next } from 'react-i18next';
import { getDatePlusYear } from './date-time-helpers';

function setLangCookie(host: string, lang: Lang) {
  const cookies = new Cookies();
  const domain = `.${host}`;
  cookies.set('lang', lang, { path: '/', expires: getDatePlusYear(), domain });
}

export function initI18n(path: string = '', host: string = '') {
  let lang: Lang = 'ru';

  if (path.startsWith('/kz/')) {
    lang = 'kk';
  }

  if (!i18n.isInitialized) {
    i18n.use(initReactI18next).init(config(lang));
    setLangCookie(host, lang);
    return lang;
  }

  if (getLang() !== lang) {
    i18n.changeLanguage(lang, (error) => {
      if (error) {
        log.error(error);
      } else {
        setLangCookie(host, lang);
      }
    });
  }

  return lang;
}
